import {MAP_MEASUREMENT_TYPE_MUTATION_KEY, mapMeasurementType} from './mapMeasurementType'
import {PIN_GLOBAL_MEASUREMENT_NAME_KEY, pinGlobalMeasurementName} from './pinGlobalMeasurementName'
import {UNMAP_MEASUREMENT_TYPE_MUTATION_KEY, unmapMeasurementType} from './unmapMeasurementType'

export const measurementsMutations = {
  [MAP_MEASUREMENT_TYPE_MUTATION_KEY]: mapMeasurementType,
  [UNMAP_MEASUREMENT_TYPE_MUTATION_KEY]: unmapMeasurementType,
  [PIN_GLOBAL_MEASUREMENT_NAME_KEY]: pinGlobalMeasurementName
}
